import { useRouteError } from "react-router";

import PropTypes from "prop-types";

import { Grid } from "@mui/material";

const errorCodeMapping = {
  401: "UNAUTHORIZED",
  403: "UNAUTHORIZED",
  404: "COULD NOT FIND PAGE OR WIDGET",
};

const ErrorPage = ({ errorMessage = "SOMETHING WENT WRONG!" }) => {
  const routeError = useRouteError();

  if (routeError?.status) {
    const errorCode = routeError.status;

    if (errorCode === 500) {
      errorMessage = routeError.data.message;
    } else {
      errorMessage = errorCodeMapping[errorCode] || `ERROR CODE ${errorCode}`;
    }
  }

  return (
    <Grid container height="100%" width="100%" alignItems="center" justifyContent="center">
      <b style={{ color: "red" }}>{errorMessage}</b>
    </Grid>
  );
};

ErrorPage.propTypes = {
  errorMessage: PropTypes.string,
};

export default ErrorPage;
